import { createFileRoute, Link } from '@tanstack/react-router'
import { useAuth } from '@/src/components/AuthContextProvider'
import { useQuery } from '@tanstack/react-query'
import { getUser } from '@/src/api/user'
import { useTranslation } from '@/src/i18n/client'

export const Route = createFileRoute('/not-permitted')({
  component: NotPermittedPage,
})

function NotPermittedPage() {
  const { t } = useTranslation('share')
  const { user } = useAuth()
  const orgName = user?.organization?.name
  const orgOwnerId = user?.organization?.ownerId

  const { data: orgOwner } = useQuery({
    queryKey: ['user', 'orgOwner', orgOwnerId],
    queryFn: () => getUser({ data: { id: orgOwnerId as string } }),
    enabled: !!orgOwnerId,
  })

  const orgOwnerLabel = orgOwner?.name || orgOwner?.email

  return (
    <div className="flex flex-col items-center justify-center px-4 text-center min-h-[60vh]">
      <h1 className="text-5xl font-bold mb-4 text-destructive">
        {t('notPermitted.errorCode')}
      </h1>
      <h2 className="text-2xl font-semibold mb-4">
        {t('notPermitted.title')}
      </h2>
      <p className="text-muted-foreground mb-8 max-w-md">
        {t('notPermitted.subtitle')}
      </p>
      <div className="mb-8 p-6 bg-muted/30 rounded-lg border border-border max-w-lg">
        <p className="text-sm text-muted-foreground mb-3 font-medium">{t('notPermitted.needAccess')}</p>
        <div className="space-y-2 text-sm text-muted-foreground">
          {orgName ? (
            <p>{t('notPermitted.contactAdmin', { orgName })}</p>
          ) : (
            <p>{t('notPermitted.contactOrgAdmin')}</p>
          )}
          {orgOwnerLabel && (
            <p className="mt-3 pt-3 border-t border-border">
              {t('notPermitted.administrator', { name: orgOwnerLabel })}
            </p>
          )}
        </div>
      </div>
      <Link
        to="/"
        className="px-6 py-2 bg-primary text-primary-foreground rounded-md hover:bg-primary/90 transition-colors font-medium"
      >
        {t('notPermitted.goHome')}
      </Link>
    </div>
  )
}
